import moment from 'moment';

export const diffInDays = (
  startDate: Date | string | moment.Moment,
  endDate: Date | string | moment.Moment,
): number => {
  const diff = moment(endDate).startOf('day').diff(moment(startDate).startOf('day'), 'days');
  return diff;
};

export const isSameDate = (a: Date, b: Date): boolean => {
  const isSameDate = a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  return isSameDate;
};

export const isDateInDates = (date: string, dates: readonly string[]): boolean => {
  const contains = dates.some((d) => {
    const dateInDates = new Date(d);
    const observedDay = new Date(date);
    const isSame = isSameDate(dateInDates, observedDay);

    return isSame;
  });

  return contains;
};
